var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-object-view"},[_c('objectTreeNode',{attrs:{"primary":true,"nowrap":_vm.nowrap,"expandButtonText":_vm.expandButtonText},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }